import { useState } from 'react'

import { EMPTY_OBJECT } from '../../../../constants/common'

export function useResizeModal({ initialFullScreen = false } = EMPTY_OBJECT) {
  const [fullScreen, setFullScreen] = useState(initialFullScreen)

  function handleResizeModal() {
    setFullScreen(prev => !prev)
  }

  return {
    fullScreen,
    handleResizeModal,
  }
}
